
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/blog-posts/how-to-bring-the-curipod-buzz-to-your-school",
      function () {
        return require("private-next-pages/c/blog-posts/how-to-bring-the-curipod-buzz-to-your-school.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/blog-posts/how-to-bring-the-curipod-buzz-to-your-school"])
      });
    }
  